// extracted by mini-css-extract-plugin
export default {"container":"BudgetDetails_container__AWDUd"};